// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"file-download"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 10.5V7L15 2H4V22H12M14 2V8H20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15.5 19.0439L19 22.5041L22.5 19.0439M19 21.3V14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FileDownloadIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-download',
    ref,
    icon: element,
  },
));

FileDownloadIcon.displayName = 'FileDownloadIcon';

export default FileDownloadIcon;
